// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartTotalStyles } from "@awc/Overrides/Widgets/Cart/CartTotal";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { css } from "styled-components";

const sharedButtonsStyle: ButtonPresentationProps = {
    variant: "primary",
    buttonType: "solid",
    css: css`
        margin: 0;
        width: 100%;
    `,
};

cartTotalStyles.cancelPunchOutButton = {
    ...sharedButtonsStyle,
};

cartTotalStyles.addAllToListButton = {
    ...sharedButtonsStyle,
};
cartTotalStyles.removeAllButton = {
    ...sharedButtonsStyle,
};
cartTotalStyles.saveOrderButton = {
    ...sharedButtonsStyle,
};
cartTotalStyles.submitQuoteButton = {
    ...sharedButtonsStyle,
};
cartTotalStyles.submitRequisitionButton = {
    ...sharedButtonsStyle,
};

cartTotalStyles.checkoutButton = {
    css: css`
        margin: 0;
    `,
};

cartTotalStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;
    `,
};

cartTotalStyles.rqfModalWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 14px;
    `,
};

cartTotalStyles.cartRfqModal = {
    sizeVariant: "large",
};
